// src/api/merchantInvoices.js
import { http } from './http'

export async function fetchMerchantInvoices() {
    const res = await http.get('/merchant/invoices')
    return res.data
}

export async function createMerchantInvoice(payload) {
    const res = await http.post('/merchant/invoices', payload)
    return res.data
}
